var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 14,
    viewBox: "0 0 24 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.77406 0C3.03284 0 0 3.14112 0 7.0182C0.357221 16.3295 13.1924 16.3251 13.5481 7.0182C13.5481 3.14216 10.515 0 6.77406 0ZM17.5925 0.411523C15.722 0.411523 14.2055 3.37015 14.2055 7.0182C14.3912 15.7854 20.7944 15.7856 20.9798 7.0182C20.9795 3.37041 19.463 0.411523 17.5925 0.411523ZM22.828 1.09886C21.2632 1.21246 21.2665 12.8304 22.8278 12.9375C24.3921 12.8247 24.3893 1.20544 22.828 1.09886Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.7568412c947384f2b1f53d60b4b93041.svg";
export { ForwardRef as ReactComponent };